<script>
    import { cart } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/stores/cart.js?1733898724755';

    import Header from '/srv/web/wyvr/html/releases/58819/gen/client/shop/cart/minicart/Header.svelte?1733898724755';
    import Footer from '/srv/web/wyvr/html/releases/58819/gen/client/shop/cart/minicart/Footer.svelte?1733898724755';
    import Item from '/srv/web/wyvr/html/releases/58819/gen/client/shop/cart/minicart/Item.svelte?1733898724755';
    import { liveProduct } from '/srv/web/wyvr/html/releases/58819/gen/client/magento2/product/live/live_product.js?1733898724755';

    export let locale;
    export let currency;

    let live_cache = {};

    $: items = get_items($cart); // get_items($cart, live_cache);
    $: count = items.reduce((acc, item) => acc + item.qty, 0);
    $: sum = items.reduce((acc, item) => acc + item.final_price * item.qty, 0);

    function get_items(cart) { // 
        if (!cart?.items) {
            return [];
        }
        return cart.items.filter(Boolean);
    }
    function get_items_live(cart, live_cache) {
        if (!cart?.items) {
            return [];
        }
        const valid_items = cart.items.filter(Boolean);
        valid_items.forEach((item) => {
            // when item in cache update the price with the data
            if (live_cache[item.sku]) {
                item.price = live_cache[item.sku]?.price || item.price;
                item.special_price = live_cache[item.sku]?.special_price;
                item.final_price =
                    item.special_price < item.price
                        ? item.special_price
                        : item.price;
                return;
            }
            // load live product data, when not in cache
            if (live_cache[item.sku] === undefined) {
                live_cache[item.sku] = false;
                liveProduct.subscribe(item.sku, update_cache);
            }
        });
        return valid_items;
    }

    function update_cache(data, sku) {
        live_cache[sku] = data;
    }
</script>

<section class="modal">
    <div class="modal-header">
        <button
            class="btn close icon-close"
            aria-label={window.__('shop.close')}
            on:click={() => document.getElementById('cart-toggle')?.click()}
        />
    </div>
    {#if items.length > 0}
        <section class="minicart">
            <header>
                <Header {count} {sum} {locale} {currency} />
            </header>
            <div class="minicart-items">
                {#each items as item (item.sku)}
                    <Item {item} {locale} {currency} />
                {/each}
            </div>
            <footer>
                <Footer />
            </footer>
        </section>
    {:else}
        <section class="minicart empty">
            <p>{window.__('cart.empty')}</p>
        </section>
    {/if}
</section>


<style>
    .modal-header {
        position: absolute;
        top: 0;
        right: 0;
        text-align: right;
    }

    .minicart > .minicart-items :global(div > div > div > a) {
        text-overflow: ellipsis;
        overflow: hidden;
        font-weight: 600;
        line-height: 1;
        color: #707070;
        text-transform: uppercase;
        text-decoration: none;
        line-height: 1;
        margin: 0;
        font-size: 1rem;
    }

    .minicart :global(.old-price) {
        line-height: 0.75rem !important;
        margin-left: 0 !important;
    }

    .minicart :global(.price--uvp) {
        margin-left: 0px !important;
        font-size: 0.75rem !important;
        font-weight: var(--h3__font-weight) !important;
        line-height: var(--h3__line-height) !important;
        color: var(--h3__color);
        margin: var(--h3__margin);
        text-transform: var(--font-heading-text-transform);
        margin-top: 0;
        margin-bottom: 0;
    }

    .minicart :global(.price.price--old) {
        font-size: 0.75rem !important;
        font-weight: var(--h3__font-weight);
        line-height: var(--h3__line-height);
        color: var(--h3__color);
        margin: var(--h3__margin);
        text-transform: var(--font-heading-text-transform);
        margin-top: 0;
        margin-bottom: 0;
    }

    .minicart :global(.price--new) {
        font-size: 1.125rem !important;
        color: #ff0505;
        font-weight: 600 !important;
    }

    .minicart :global(.price) {
        font-weight: 400;
        font-size: 1rem;
        line-height: 1;
        margin: 0;
    }

    .minicart {
        display: flex;
        height: 100%;
        flex-direction: column;
        max-width: 500px;
    }

    .minicart .minicart-items {
        flex-grow: 1;
        overflow-y: auto;
        max-height: 20vh;

        @media (min-height: 600px) {
            max-height: 25vh;
        }

        @media (min-height: 768px) {
            max-height: 35vh;
        }

        @media (min-width: 992px) {
            padding: 0.5rem;
        }

        @media (min-width: 1440px) {
            padding: 1rem;
        }
    }

    .minicart header {
        /* border-bottom: 1px solid var(--color-text); */

        @media (min-width: 992px) {
            padding: 0.5rem;
        }

        @media (min-width: 1440px) {
            padding: 1rem;
        }
    }

    .minicart footer {
        padding-bottom: 0;
        /* border-top: 1px solid var(--color-text); */
    }
    .empty {
        padding-bottom: 1rem;
    }
</style>